<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-row>
              <b-col lg="12" sm="12">
                    <b-overlay :show="unitLoad">
                        <b-col lg="12" sm="12">
                            <b-row>
                                <b-col xs="12" sm="12" md="12" class="text-right mb-2">
                                    <b-button @click="pdfExport()" variant="success">{{  $t('globalTrans.export_pdf') }}</b-button>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col class="text-center" lg="12" sm="12">
                                    <h6 class="m-auto">{{$t('globalTrans.organization')}} : {{ $i18n.locale === 'bn' ? assessment.organization_name_bn : assessment.organization_name }}</h6>
                                    <h3 class="w-50 m-auto rounded font-weight-bold pb-3">
                                        {{ $i18n.locale === 'bn' ? assessment.institute_name_bn : assessment.institute_name }}
                                    </h3>
                                    <h5 class="text-white w-25 m-auto rounded font-weight-bold p-1 bg-dark">{{ $t('ds_exam_management.progress_letter') }}</h5>
                                    <h6 class="m-auto pt-2">{{ $t('ds_exam_management.academic_year') }} - {{ $n(assessment.year, {useGrouping: false}) }}</h6>
                                </b-col>
                            </b-row>
                            <hr>
                            <b-row>
                                <b-col lg="6" sm="6">
                                    <div class="text-dark font-weight-bold w-25 float-left">{{ $t('ds_institute_management.student_name') }}</div>
                                    <div class="text-dark">: {{ $i18n.locale === 'bn' ? assessment.student.name_bn : assessment.student.name_en }}</div>
                                </b-col>
                                <b-col lg="6" sm="6">
                                    <div class="text-dark font-weight-bold w-25 float-left">{{ $t('ds_institute_management.class') }}</div>
                                    <div class="text-dark">: {{ $i18n.locale === 'bn' ? assessment.class_name_bn : assessment.class_name }}</div>
                                </b-col>
                                <b-col lg="6" sm="6">
                                    <div class="text-dark font-weight-bold w-25 float-left">{{ $t('ds_student_management.student_roll') }}</div>
                                    <div class="text-dark">: {{ $n(assessment.student.student_id, { useGrouping: false }) }}</div>
                                </b-col>
                            </b-row>
                        </b-col>
                        <!-- Curriculum Info  -->
                        <b-col class="mt-4" v-if="slotdatas.length > 0" lg="12" sm="12">
                            <b-row v-for="(slots, index) in slotdatas" :key="index">
                                <b-col lg="12" sm="12">
                                    <div class="bg-success py-1 mb-2 col rounded-left">
                                        <h5 class="text-white text-center"> {{ getSlotName(slots.iep_slot_id) }}</h5>
                                    </div>
                                    <b-table-simple bordered small>
                                        <tbody>
                                            <span hidden>{{ $i = 0 }}</span>
                                            <b-tr>
                                                <b-th class="align-middle text-center">{{ $t('ds_student_management.skill_name') }}</b-th>
                                                <b-th class="align-middle">
                                                    <b-list-group flush class="list">
                                                        <b-list-group-item class="bg-light px-2 py-0">
                                                            <b-row align-v="center">
                                                                <b-col md="auto">
                                                                </b-col>
                                                                <b-col>
                                                                    <small>{{ $t('ds_student_management.scheduled_work') }}</small>
                                                                </b-col>
                                                                <b-col>
                                                                    <small>{{ $t('ds_student_management.previous_status') }}</small>
                                                                </b-col>
                                                                <b-col>
                                                                    <small>{{ $t('ds_student_management.current_status') }}</small>
                                                                </b-col>
                                                                <b-col>
                                                                    <small>{{ $t('ds_student_management.comments_evaluation') }}</small>
                                                                </b-col>
                                                            </b-row>
                                                        </b-list-group-item>
                                                    </b-list-group>
                                                </b-th>
                                            </b-tr>
                                            <b-tr v-for="(type, index) in slots.curriculums" :key="index">
                                                <b-th class="align-middle" width="20%">{{ $i18n.locale === 'bn' ? type.type_name_bn : type.type_name }}</b-th>
                                                <b-td>
                                                    <b-list-group flush class="list">
                                                        <b-list-group-item v-for="(item, indx) in type.activities" :key="indx" class="px-2 py-1">
                                                            <span hidden>{{ $i++ }}</span>
                                                            <b-row align-v="center" >
                                                                <b-col md="auto">
                                                                    <span>{{ $n($i) + '.' }}</span>
                                                                </b-col>
                                                                <b-col>
                                                                    <h6 class="mb-0">
                                                                        <span>{{ $i18n.locale === 'bn' ? item.activity_name_bn : item.activity_name }}</span>
                                                                    </h6>
                                                                </b-col>
                                                                <b-col>
                                                                        <h6 class="mb-0">{{ $n(item.average_marks, { useGrouping: false }) }}</h6>
                                                                </b-col>
                                                                <b-col>
                                                                    <h6>{{ $n(item.marks, { useGrouping: false }) }}</h6>
                                                                </b-col>
                                                                <b-col>
                                                                    <h6 v-if="item.remarks" class="mb-0">
                                                                        <span v-if="item.remarks == 'v_good'">{{ $i18n.locale === 'en' ? 'Very good' : 'খুব ভাল' }}</span>
                                                                        <span v-else-if="item.remarks == 'good'">{{ $i18n.locale === 'en' ? 'Good' : 'ভাল' }}</span>
                                                                        <span v-else-if="item.remarks == 'satis'">{{ $i18n.locale === 'en' ? 'Satisfactory' : 'সন্তোষজনক' }}</span>
                                                                        <span v-else>{{ $i18n.locale === 'en' ? 'Need to improve' : 'উন্নতি করতে হবে' }}</span>
                                                                    </h6>
                                                                    <h6 v-else>-</h6>
                                                                </b-col>
                                                            </b-row>
                                                        </b-list-group-item>
                                                    </b-list-group>
                                                </b-td>
                                            </b-tr>
                                        </tbody>
                                    </b-table-simple>
                                </b-col>
                            </b-row>
                        </b-col>
                        <!-- End Curriculum Info  -->
                        <!-- Course Info  -->
                        <b-col v-if="coursesData.length > 0" lg="12" sm="12">
                            <b-row>
                                <b-col class="text-center" lg="12" sm="12">
                                    <h5 class="text-white w-25 m-auto rounded font-weight-bold p-1 bg-dark">{{ $t('ds_exam_management.result') }}</h5>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col v-for="(c_slot, index) in coursesData" :key="index" lg="6" sm="12" :class="coursesData.length === 1 ? 'm-auto' : ''">
                                    <b-table-simple class="tg mt-3 mb-0" bordered hover small caption-top responsive>
                                        <b-thead>
                                            <b-tr>
                                                <td class="text-center" colspan="4"><strong>{{ getSlotName(c_slot.iep_slot_id) }}</strong></td>
                                            </b-tr>
                                            <b-tr class="bg-success">
                                                <b-th class="align-middle">{{ $t('ds_exam_management.course_sub_name') }}</b-th>
                                                <b-th class="align-middle">{{ $t('ds_config.total_mark') }}</b-th>
                                                <b-th class="align-middle">{{ $t('ds_config.pass_mark') }}</b-th>
                                                <b-th class="align-middle" width="15%">{{ $t('ds_student_management.obtained_marks') }}</b-th>
                                            </b-tr>
                                        </b-thead>
                                        <b-tbody>
                                            <tr v-for="(course, index) in c_slot.details" :key="index">
                                                <b-td class="text-left">{{ getCourseName(course.course_id) }}</b-td>
                                                <b-td class="text-center">{{ $n(course.total_marks, { useGrouping: false }) }}</b-td>
                                                <b-td class="text-center">{{ $n(course.pass_marks, { useGrouping: false }) }}</b-td>
                                                <b-td class="text-center">{{ $n(course.obtain_marks, { useGrouping: false }) }}</b-td>
                                            </tr>
                                        </b-tbody>
                                    </b-table-simple>
                                </b-col>
                            </b-row>
                        </b-col>
                        <!-- End Course Info -->
                        <!-- Home Work Evaluations -->
                        <b-col v-if="homeworkData.length > 0" lg="12" sm="12">
                            <b-row>
                                <b-col class="text-center" lg="12" sm="12">
                                    <h5 class="text-white w-25 m-auto rounded font-weight-bold p-1 bg-dark">{{ $t('ds_exam_management.homework_evaluation') }}</h5>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col v-for="(work, index) in homeworkData" :key="index" lg="6" sm="12" :class="homeworkData.length === 1 ? 'm-auto' : ''">
                                    <b-table-simple class="tg mt-3 mb-0" bordered hover small caption-top responsive>
                                        <b-thead>
                                            <b-tr>
                                                <td class="text-center" colspan="4"><strong>{{ getSlotName(work.iep_slot_id) }}</strong></td>
                                            </b-tr>
                                            <b-tr class="bg-success">
                                                <b-th class="align-middle text-center">{{ $t('home_work.subject') }}</b-th>
                                                <b-th class="align-middle text-center">{{ $t('globalTrans.status') }}</b-th>
                                                <b-th class="align-middle text-center">{{ $t('ds_student_management.comments_evaluation') }}</b-th>
                                            </b-tr>
                                        </b-thead>
                                        <b-tbody>
                                            <tr v-for="(home, indx) in work.details" :key="indx">
                                                <b-td class="text-left">{{ getObservationName(home.observation_type) }}</b-td>
                                                <b-td class="text-center">
                                                    {{ getOption.find(itm => itm.value === home.is_regular).text }}
                                                </b-td>
                                                <b-td class="text-center">
                                                    {{ getOption2.find(itm => itm.value === home.is_satisfied).text }}
                                                </b-td>
                                            </tr>
                                        </b-tbody>
                                    </b-table-simple>
                                </b-col>
                            </b-row>
                        </b-col>
                        <!-- End Home work evaluations -->
                        <!-- Efficiency Assessment -->
                        <b-col v-if="slotdatas.length > 0" lg="12" sm="12">
                            <b-row>
                                <b-col class="text-center" lg="12" sm="12">
                                    <h5 class="text-white w-25 m-auto rounded font-weight-bold p-1 bg-dark">{{ $t('ds_exam_management.efficiency_assessment') }}</h5>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col v-for="(slots, index) in slotdatas" :key="index" lg="6" sm="12" :class="slotdatas.length === 1 ? 'm-auto' : ''">
                                    <b-table-simple class="tg mt-3 mb-0" bordered small caption-top responsive>
                                        <b-thead>
                                            <b-tr>
                                                <td class="text-center" colspan="2"><strong>{{ getSlotName(slots.iep_slot_id) }}</strong></td>
                                            </b-tr>
                                        </b-thead>
                                        <b-tbody v-if="gradeList.length > 0">
                                            <b-tr v-for="(grade, indx) in gradeList" :key="indx">
                                                <td width="5%">
                                                    <span v-if="parseInt(grade.mark_from) <= parseInt(slots.avg) && parseInt(slots.avg) <= parseInt(grade.mark_to)">
                                                        <i class="fas fa-check text-success mr-1"></i> {{ $i18n.locale === 'bn' ? grade.text_bn : grade.text_en }}
                                                    </span>
                                                    <span v-else class="pl-4">{{ $i18n.locale === 'bn' ? grade.text_bn : grade.text_en }}</span>
                                                </td>
                                                <td>{{ $i18n.locale === 'bn' ? grade.remarks_bn : grade.remarks_en }}</td>
                                            </b-tr>
                                        </b-tbody>
                                    </b-table-simple>
                                </b-col>
                            </b-row>
                        </b-col>
                        <!-- End Efficiency Assessment -->
                         <!-- School Rules -->
                        <b-col v-if="schoolRulesList.length > 0" lg="12" sm="12">
                            <b-row>
                                <b-col class="text-center mb-3" lg="12" sm="12">
                                    <h5 class="text-white w-50 m-auto rounded font-weight-bold p-1 bg-dark">{{ $t('ds_exam_management.school_rules') }}</h5>
                                </b-col>
                                <b-col v-for="(rules, index) in schoolRulesList" :key="index" lg="12" sm="12">
                                    <div class="text-dark">
                                        <span><i class="fas fa-bahai"></i> {{ rules.text }}</span>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-col>
                        <!-- End School Rules -->
                        <b-col>
                            <div class="row">
                                <div class="col-sm-3"></div>
                                <div class="col text-right">
                                    <b-button variant="danger" @click="$bvModal.hide('modal-2')">{{ $t('globalTrans.cancel') }}</b-button>
                                </div>
                            </div>
                        </b-col>
                    </b-overlay>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import RestApi, { disabilitySchoolServiceBaseUrl } from '@/config/api_config'
import { progressLetterDetailApi } from '../../api/routes'
import Custom from '../../../store/custom'
import ExportPdf from './export-pdf'

export default {
  props: ['id', 'item'],
  components: {
  },
  data () {
    return {
      unitLoad: false,
      assessment: {},
      slotdatas: [],
      coursesData: [],
      homeworkData: []
    }
  },
  created () {
    if (this.id) {
        this.assessment = this.item
        this.getAssingedCurricular()
    }
  },
  mounted () {
    core.index()
  },
  computed: {
    getOption: function () {
        return [
            { value: 1, text: this.$i18n.locale === 'en' ? 'Regular' : 'নিয়মিত' },
            { value: 2, text: this.$i18n.locale === 'en' ? 'Irregular' : 'অনিয়মিত' }
        ]
    },
    getOption2: function () {
        return [
            { value: 1, text: this.$i18n.locale === 'en' ? 'Satisfactory' : 'সন্তোষজনক' },
            { value: 2, text: this.$i18n.locale === 'en' ? 'Dissatisfactory' : 'অসন্তোষজনক' }
        ]
    },
    schoolRulesList: function () {
        return Custom.schoolRulesList.map(el => {
            return Object.assign({}, el, { text: this.$i18n.locale === 'bn' ? el.text_bn : el.text_en })
        })
    },
    gradeList: function () {
        return this.$store.state.DisabilitySchoolService.commonObj.gradeList.filter(item => item.status === 1)
    },
    currentLocale () {
        return this.$i18n.locale
    }
  },
  watch: {
  },
  methods: {
    pdfExport () {
        const myData = {
            assessment: this.assessment,
            slotdatas: this.slotdatas,
            coursesData: this.coursesData,
            homeworkData: this.homeworkData
        }
        const reportTitle = this.$t('ds_exam_management.progress_letter')
        ExportPdf.exportPdfDetails(reportTitle, myData, this)
        // ExportPdf.exportPdfDetails(disabilitySchoolServiceBaseUrl, 'configuration/report-heading/detail', 2, reportTitle, myData, this)
    },
    getObservationName (Id) {
        const tmpSlot = Custom.observationList.find(obs => obs.value === Id)
        if (this.$i18n.locale === 'bn') {
            return tmpSlot.text_bn
        } else {
            return tmpSlot.text_en
        }
    },
    getSlotName (Id) {
        const tmpSlot = this.$store.state.DisabilitySchoolService.commonObj.IepSlotList.find(slot => slot.value === Id)
        if (this.$i18n.locale === 'bn') {
            return tmpSlot.text_bn
        } else {
            return tmpSlot.text_en
        }
    },
    getCourseName (Id) {
        const tmpSlot = this.$store.state.DisabilitySchoolService.commonObj.courseNameList.find(slot => slot.value === Id)
        if (this.$i18n.locale === 'bn') {
            return tmpSlot.text_bn
        } else {
            return tmpSlot.text_en
        }
    },
    getAssingedCurricular () {
        this.unitLoad = true
        const myData = {
            year: this.item.year,
            office_id: this.item.office_id,
            class_id: this.item.class_id,
            iep_slot_id: this.item.iep_slot_id,
            single_result: 1 // 1 means = its for slot wise result not overall result
        }
        RestApi.getData(disabilitySchoolServiceBaseUrl, `${progressLetterDetailApi}/${this.item.applicant_id}`, myData).then(response => {
            if (response.success) {
                this.slotdatas = this.getRelationalData(response.curriculumsData)
                this.coursesData = response.coursesData
                this.homeworkData = response.homeworkData
            }
            this.unitLoad = false
        })
    },
    getRelationalData (data) {
        const mainData = data.map(mItem => {
            const listData = Object.keys(mItem.curriculums).map(key => {
                const tmpType = this.$store.state.DisabilitySchoolService.commonObj.curricularTypeList.find(el => el.value === parseInt(key))
                const newData = {
                    type_name: tmpType !== undefined ? tmpType.text_en : '',
                    type_name_bn: tmpType !== undefined ? tmpType.text_bn : '',
                    curricular_type_id: key
                }
                const arryList = mItem.curriculums[key].map(item => {
                    const activityData = Object.assign({
                        curricular_activity_id: item.curricular_activity_id,
                        activity_name: item.curricular_activity.activity_name,
                        activity_name_bn: item.curricular_activity.activity_name_bn,
                        average_marks: item.average_marks,
                        marks: item.marks,
                        remarks: item.remarks
                    })
                    return activityData
                })
                newData.activities = arryList
                return newData
            })
            // return listData
            return Object.assign({}, mItem, { curriculums: listData })
        })
        return mainData
    }
  }
}
</script>
